export default "__VITE_ASSET__9bO0hBVC__"